import ETC_AXIOS from '../api/etc.axios'
import ETC from '../config/etc.config'
import APP from '../config/app.config'

export default {
  // 当前订单流程
  // currentOrderStatus(data) {
  //   return ETC_AXIOS.post('/apply/current-order-flow-step', data)
  // },
  changeBank(data) {
    return ETC_AXIOS.post(APP.HTTP_URL2 + '/apply-prepay/change-bank-card', data)
  },
  // 校验车牌
  pakdApply(data) {
    return ETC_AXIOS.post(APP.HTTP_URL + '/bank/ping-an-pocket/transaction-info-notify', data)
  },
  // 校验车牌
  // checkPlateNo(data) {
  //   return ETC_AXIOS.post(APP.HTTP_URL2 + '/apply-prepay/check-plate-by-issuer', data)
  // },
  // 修改地址
  modifyAddress(data) {
    return ETC_AXIOS.post(APP.HTTP_URL2 + '/apply-prepay/modify-address-before-pay', data)
  },
  // 建议银行
  optionBank(data) {
    return ETC_AXIOS.post(APP.HTTP_URL2 + '/questionnaire-answer/answer', data)
  },
  // 获取商品信息
  getApplyGoods (data) {
    return ETC_AXIOS.post(APP.HTTP_URL2 + '/apply-prepay/goods-detail', {coord_type: 1, ...data}).then(res => {
      return res
    })
  },
  // 获取评论列表
  getCommentList (data) {
    return ETC_AXIOS.post(APP.HTTP_URL2 + '/apply-prepay/comments', {page_size: 10, ...data})
  },
  // 修改省份
  // changeProvince (data) {
  //   return ETC_AXIOS.post(APP.HTTP_URL2 + '/apply-prepay/change-province', {coord_type: 1, ...data})
  // },
  // 提交收货地址
  submitAddress (data) {
    return ETC_AXIOS.post(APP.HTTP_URL2 + '/apply-prepay/submit-address', {coord_type: 1, ...data})
  },
  // 选择支付类型
  choosePayType (data) {
    data.source = ETC.APP_CHANNEL_PL[localStorage.getItem(ETC.LOCAL_STORAGE_KEY.APP_FROM_CHANNEL)] || ''
    return ETC_AXIOS.post('/apply-prepay/purchase-obu', data)
  },
  // saveCreditStatus(data) {
  //   return ETC_AXIOS.post('/activity/free-apply/save', data)
  // },
  // getCreditApplyStatus(data) {
  //   return ETC_AXIOS.post('/activity/free-apply/apply-status', data)
  // },
  // getCreditAuditStatus(data) {
  //   return ETC_AXIOS.post('/activity/free-apply/get-audit-result', data)
  // },
  // uploadCreditInfo(data) {
  //   return ETC_AXIOS.post('/activity/free-apply/apply-credit-card', data)
  // },
  entrustContract(data) { // 签约免密
    return ETC_AXIOS.post('/apply/new-entrust-contract', data)
  },
  checkEntrustStatus(data) { // 签约免密（查询）
    return ETC_AXIOS.post('/apply/check-entrust-status', data)
  },
  entrustCheck(data) { // 签约免密（查询）新
    return ETC_AXIOS.post(APP.HTTP_APPLY_URL + '/entrust/check', data)
  },
  customService(data) {
    return ETC_AXIOS.post(APP.HTTP_URL2 + '/no-login/new-customer-order-info', data, {
      headers: {
        'x-app-source': 6
      }
    })
  },
  // 招行保存推荐人
  zhaohangReferrer(data) {
    return ETC_AXIOS.post('/bank/cmb/referrer/save', data)
  }
}
